<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 9/10/2020
  -->

<template>
	<div class="fill-height-root coaching-process-list-root">

		<div class="row px-4 my-3 pb-3">
			<div class="layout-spacer"></div>
			<el-button class="my-auto" type="primary" size="small" @click="onCreateTemplateClicked">
				+ New coaching program
			</el-button>
		</div>
		<PagerTable
			ref="pagerTable"
			:dataArray="templateList"
			:analytics-props="analyticsPropsMethod()"
			@onLoadMore="onLoadMore">


			<template #items-container="{dataArray}">
				<div class="row mx-0">
					<TemplateListItem
						v-for="(item, index) in dataArray" :key="index"
						class="col-lg-4 col-sm-12 col-md-6 mb-4 fill-height"
						:program="item"
						:index="index"
					@click.native="openTemplate(item)"/>
				</div>
			</template>

			<template #empty-view>
				<div class="text-center">
					<div class="d-flex justify-content-center mb-5">
						<div shadow="never" style="width: 30%;">
							<img :src="require('@/assets/images/program_template.png')" style="width: 100%;"/>
						</div>
					</div>
					<h2 class="mb-4">Your coaching programs will be shown here.</h2>
					<h4 class="">Create your coaching program and invite your first client to get started.</h4>
					<div class="my-5">
						<qw-button type="primary"
								   class="font-size-4 py-3 px-5"
								   @click="onCreateTemplateClicked">
							Create coaching program
						</qw-button>
					</div>
					<div class="mx-auto col-md-6">Coaching program allows you to outline your typical coaching process and to reuse it for different clients. You can adjust each program further for each client as needed.</div>

				</div>
			</template>


		</PagerTable>
		<dialogs-wrapper name="program-wizard"/>
	</div>
</template>

<script>

import BasePagerView from "@/core/components/Data/BasePagerView.vue";
import TemplateListItem from "@/core/modules/coach/Coaching/Templates/TemplateItemView.vue";
import PagerTable from "@/core/components/Data/PagerTable.vue";
import {createDrawer} from "@/utils/helpers-external";
import TemplateCreationWizard from "@/core/modules/coach/Coaching/Templates/Wizard/TemplateCreationWizard.vue";

const programCreationWizard = createDrawer(TemplateCreationWizard, {wrapper: "program-wizard"})

export default {
	name: "ProgramTemplateList",
	components: {PagerTable, TemplateListItem},
	extends: BasePagerView,

	props:{
		wizard: String
	},

	data(){
		return {

			templateList: [],
			showCreationWizard: false,
			programCreationWizardObj: null
		}
	},

	mounted(){
	},

	methods: {

		showProgramWizardIfNeeded(){
			console.log("showProgramWizardIfNeeded: this.wizard = ", this.wizard)
			if(this.wizard === "program"){
				this.showWizard()
			}
		},

		async tabBeforeLeave(){
			await this.forceHideWizard()
		},

		onTabOpened(){
			console.log("ProgramTemplateList: onTabOpened")
			this.showProgramWizardIfNeeded()
		},

		getTableView(pagerKey) {
			return this.$refs.pagerTable
		},
		getDataField(pagerKey) {
			return this.templateList
		},

		async dataPagerProvider() {
			console.log("ProgramTemplateList: dataPagerProvider")
			return this.$dataManager.getProgramTemplatesPager(12)
		},

		async onCreateTemplateClicked(){
			let _ = this.$analyticManager.trackEvent("Create program template clicked.", this.analyticsPropsMethod())
			await this.showWizard()
		},

		onDataChanged(){
		},

		async forceHideWizard(){
			if(this.programCreationWizardObj){
				let dialog = await this.programCreationWizardObj.getInstance()
				await dialog.onCancel()
				this.programCreationWizardObj = null
			}
		},

		async showWizard(){
			await this.forceHideWizard()
			this.programCreationWizardObj = programCreationWizard()
			let programItem = await this.programCreationWizardObj
			console.log("onCreateTemplateClicked: res = ", programItem)
			if(programItem){
				this.openTemplate(programItem)
			}
		},


		openTemplate(template){
			this.$analyticManager.trackEvent("Open program template clicked", {program_name: template.name, id: template.id, ...this.analyticsPropsMethod()})
			this.go("ProgramTemplateDetailsCoach", {templateId: template.id})
		},

		analyticsPropsInternal(){
			return {
				category: "Program template list"
			}
		}
	},
}
</script>

<style lang="scss">

</style>
